export default __webpack_public_path__ + "static/media/10.5c67ce44.jpg";